export default (app) => {
  return {
    namespaced: true,
    state: {
      tablesNeedRefresh: false,
      items: [],
    },
    mutations: {
      addItem(state, item) {
        state.items.push(item)
      },
      removeItem(state, name) {
        if (state.items.length > 0) {
          state.items.find((item, index) => {
            if (typeof item !== 'undefined') {
              if (item.name === name) {
                state.items.splice(index, 1)
              }
            }
          })
        }
      },
      setTablesNeedRefresh(state, v) {
        state.tablesNeedRefresh = v
      },
    },
    actions: {
      addItem(context, item) {
        context.commit('addItem', item)
      },
      removeItem(context, item) {
        context.commit('removeItem', item)
      },
      tablesNeedRefresh(context, v) {
        context.commit('setTablesNeedRefresh', v)
      },
    },
  }
}
